import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLookups } from './lookupSlice';
import Loader from '../Components/Common/Loader';
import { useNavigate } from 'react-router-dom';

export default function Root({ children }) {
  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.lookup);
  const navigate = useNavigate();

  useEffect(() => {
    if (!data) dispatch(fetchLookups());
  }, [dispatch, data, navigate]);

  if (isLoading) return <Loader />;
  return (
    <>
      {children}
    </>
  );
}
